import { AHText, AHTextFonts, AHIcon } from "arkh";
import React from "react";
import { TaskOptionsOption } from "./TaskOptionsOption";
import { FollowupMissed } from "./FollowupMissed";
import { graphql, useFragment } from "react-relay";
import { RoutineOccasionFollowupResultCell_taskExecution$key } from "./__generated__/RoutineOccasionFollowupResultCell_taskExecution.graphql";

export function RoutineOccasionFollowupResultCell(props: {
  taskExecution: RoutineOccasionFollowupResultCell_taskExecution$key;
}) {
  const taskExecution = useFragment(
    graphql`
      fragment RoutineOccasionFollowupResultCell_taskExecution on TaskExecution {
        __typename
        isOptional
        ... on TaskExecutionCheck {
          checkValue
        }
        ... on TaskExecutionNumber {
          formattedNumberValue
        }
        ... on TaskExecutionText {
          textValue
        }
      }
    `,
    props.taskExecution
  );

  switch (taskExecution.__typename) {
    case "TaskExecutionNumber": {
      return taskExecution.formattedNumberValue ? (
        <AHText
          font={AHTextFonts.BOLD}
          style={{ textAlign: "center" }}
          type="body"
        >
          {taskExecution.formattedNumberValue}
        </AHText>
      ) : (
        <FollowupMissed isOptional={taskExecution.isOptional} />
      );
    }
    case "TaskExecutionCheck": {
      return taskExecution.checkValue ? (
        <TaskOptionsOption sentiment={taskExecution.checkValue} size="small" />
      ) : (
        <FollowupMissed isOptional={taskExecution.isOptional} />
      );
    }
    case "TaskExecutionText": {
      return taskExecution.textValue ? (
        <AHText style={{ fontFamily: AHTextFonts.BOLD }} type="body">
          <AHIcon type="instructions" forceSize={15} />
        </AHText>
      ) : (
        <FollowupMissed isOptional={taskExecution.isOptional} />
      );
    }
  }
  return null;
}
